const AlternativeFormats = () => {
  // on click of block-accordion__toggle, toggle aria-expanded
  const toggle = document.querySelectorAll(
    ".block-alternative-formats__toggle"
  );

  if (toggle) {
    toggle.forEach((el) => {
      el.addEventListener("click", (e) => {
        const target = e.currentTarget;
        const expanded = target.getAttribute("aria-expanded") === "true";

        target.setAttribute("aria-expanded", !expanded);
      });
    });
  }
};

export default AlternativeFormats;
